import { mobileAppUrl } from '@/environment';
import logo from '@/images/did_logo_dark.svg';
import { useAnalytics } from '@/services/analytics';
import { AppRoutes } from '@/utils/types';
import { isAndroid, isIOS } from '@/utils/utils';
import styled from '@emotion/styled';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dotsGray from './images/dots-gray.svg';
import dotsOrange from './images/dots-orange.svg';

const Container = styled.div`
    height: 100dvh;
    width: 100dvw;
    overflow: hidden;
    background: white;
    position: relative;
`;

const DotsOrange = styled.img`
    position: absolute;
    top: 0;
    right: 0;
`;

const DotsGray = styled.img`
    position: absolute;
    bottom: 0;
    left: 0;
`;

const Logo = styled.img`
    width: 48px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    gap: 24px;
    padding: 0 24px;

    color: ${({ theme }) => theme.colors.secondary[900]};
    text-align: center;
    font-size: 14px;
    letter-spacing: 0.15px;
`;

const Title = styled.span`
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.4px;
`;

const Subtitle = styled.span`
    font-weight: 500;
`;

const Footer = styled.div`
    font-weight: 500;
    line-height: 160%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 32px;
`;

const Link = styled.span`
    font-weight: 600;
    line-height: 160%;
    text-decoration-line: underline;
`;

export const MobileHomePage = () => {
    const mixpanel = useAnalytics();
    const navigate = useNavigate();

    const isAndroidDevice = isAndroid();
    const isIosDevice = isIOS();

    useEffect(() => {
        if (!isAndroidDevice && !isIosDevice) {
            navigate(AppRoutes.Home);
        }
    }, []);

    const [os, url] = isAndroidDevice ? ['android', mobileAppUrl] : ['ios', mobileAppUrl];

    const handleRedirect = () => {
        mixpanel?.track('app-redirect', { os, event: 'redirect' });

        window.location.href = url;
    };

    return (
        <Container>
            <DotsOrange src={dotsOrange} />
            <DotsGray src={dotsGray} />

            <Content>
                <Logo src={logo} />
                <Title>Switch to desktop for the best experience</Title>
                <Subtitle>
                    Some features are desktop-only. <br /> For the full experience, please continue on your desktop browser.
                </Subtitle>

                <Footer>
                    <Link onClick={handleRedirect}>Download our app</Link>
                    to create videos on the go
                </Footer>
            </Content>
        </Container>
    );
};
